var _ellipse, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameitHashtag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Nameit",
    "data-name": "#Nameit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.001,
    height: 50,
    viewBox: "0 0 118.001 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 59.001,
    cy: 25,
    rx: 59.001,
    ry: 25,
    fill: "#005074"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_NAMEIT-2",
    "data-name": "#NAMEIT",
    transform: "translate(56.541 31.942)",
    fill: "#fff",
    fontSize: 21,
    fontFamily: "OpenSans-ExtraboldItalic, Open Sans",
    fontWeight: 800,
    fontStyle: "italic",
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.492,
    y: 0
  }, "#NAMEIT"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameitHashtag);
export default __webpack_public_path__ + "static/media/nameit_hashtag.1a1b09abd1d480a785b7a3fb354b4a87.svg";
export { ForwardRef as ReactComponent };